import React from 'react'
import { getFirstNotEmpty } from '@corratech/pylot-utils'
import { useStoreConfig } from 'config'
import { getCanonical } from '../util'
import Head from 'next/head'

export interface CommonBlogInterface {
    title: string
    meta_title: string
    meta_description: string
}

export type CommonBlogProps = {
    blog?: CommonBlogInterface
    pathname: string
    titleOverride?: string
    descriptionOverride?: string
}

export const CommonBlog = ({
    blog,
    pathname,
    titleOverride,
    descriptionOverride
}: CommonBlogProps): JSX.Element => {
    const config = useStoreConfig()
    const { seo } = config

    const title = getFirstNotEmpty([
        titleOverride,
        blog?.meta_title,
        seo.default.title
    ])

    const description = getFirstNotEmpty([
        descriptionOverride,
        blog?.meta_description,
        seo.default.description
    ])

    return (
        <Head>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={String(description)} />
            <link
                rel="canonical"
                href={getCanonical(pathname, config.base.url.baseUrl)}
            />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta
                property="twitter:domain"
                content={seo.default.twitter?.handle}
            />
            <meta
                property="twitter:url"
                content={getCanonical(pathname, config.base.url.baseUrl)}
            />
            <meta name="twitter:card" content={seo.default.twitter?.cardType} />
            <meta
                property="og:url"
                content={getCanonical(pathname, config.base.url.baseUrl)}
            />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta
                name="p:domain_verify"
                content="f000ff9735a3c025e5f36e6833393400"
            />
        </Head>
    )
}
